import { atom } from 'jotai';

export const showChartsFlag = atom(false);